import helper from '../../utils/helper.js'
// import VueToast from 'vue-toast-notification'
import Vue from 'vue'

const BaseURL = process.env.VUE_APP_BASE_PATH
// const BaseURL = ''

let headerConfig = {
	Accept: 'application/json',
	'Content-Type': 'application/json',
	'Cache-Control': 'no-cache',
}

const defaultMessage = 'Got errors when call api'

// config retries params
const retryMaxTimes = 5
const retryDelay = 200
const retryOnCodes = [403]
const defaultRetriesMessage = 'Your site will be reload because gateway issues'

let retryOptions = {
	retries: retryMaxTimes,
	retryDelay: retryDelay,
}

if (retryOnCodes.length) {
	retryOptions.retryOn = retryOnCodes
}

const originalFetch = require('isomorphic-fetch')
const fetch = require('fetch-retry')(originalFetch, retryOptions)

const baseApi = {
	handleRetries(statusCode) {
		if (!retryOnCodes.includes(statusCode)) {
			return false
		}

		if (retryOnCodes.includes(statusCode)) {
			Vue.$toast.open({
				message: defaultRetriesMessage,
				type: 'error',
				duration: 0,
			})

			setTimeout(() => {
				window.open(window.location.href, '_self')
			}, 3000)

			return true
		}
	},

	async get(endPoint) {
		let statusCode = ''
		try {
			var res = await fetch(BaseURL + endPoint, {
				method: 'GET',
				headers: headerConfig,
			})
			let data = await res.json()
			return data
		} catch (error) {
			this.handleRetries(statusCode)

			return error
		}
	},

	async post(endPoint, body) {
		let statusCode = ''
		try {
			let postHeader = {
				...headerConfig,
				'X-CSRF-TOKEN': helper.getAntiForgeryToken(),
			}

			const requestOptions = {
				method: 'POST',
				headers: postHeader,
				body: JSON.stringify(body),
			}
			let response = await fetch(BaseURL + endPoint, requestOptions)
			statusCode = response.status

			let data = ''
			const contentType = response.headers.get('Content-Type')

			if (contentType && contentType.includes('application/json')) {
				data = await response.json()
			} else if (contentType && contentType.includes('application/pdf')) {
				data = await response.blob()
			}

			if (response.status === 200) {
				return data
			} else {
				this.handleRetries(statusCode)
				const error = (data && data.message) || data || response.status || response.text()
				return Promise.reject(error)
			}
		} catch (error) {
			this.handleRetries(statusCode)

			if (!helper.isExist('.AspNetCore.Antiforgery.')) {
				alert('Please hard reload (Ctrl + F5) your site because x-csrf expired.')
				window.open(window.location.href, '_self')
			}
			return error
		}
	},

	async uploadFiles(endPoint, formData) {
		let statusCode = ''
		try {
			let response = await fetch(BaseURL + endPoint, {
				method: 'POST',
				body: formData,
				headers: {
					'X-CSRF-TOKEN': helper.getAntiForgeryToken(),
				},
			})

			statusCode = response.status
			if (response.status === 200) {
				return await response.json()
			} else {
				const isRetries = this.handleRetries(statusCode)
				const errorMessage = isRetries ? '' : (await response.text()) || defaultMessage
				return Promise.reject(errorMessage)
			}
		} catch (error) {}
	},
}

export default baseApi
